import { render, staticRenderFns } from "./CashierPopup.vue?vue&type=template&id=2c5b88bd&scoped=true"
import script from "./CashierPopup.vue?vue&type=script&lang=js"
export * from "./CashierPopup.vue?vue&type=script&lang=js"
import style0 from "./CashierPopup.vue?vue&type=style&index=0&id=2c5b88bd&lang=scss&scoped=true"
import style1 from "./CashierPopup.vue?vue&type=style&index=1&id=2c5b88bd&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b88bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5b88bd')) {
      api.createRecord('2c5b88bd', component.options)
    } else {
      api.reload('2c5b88bd', component.options)
    }
    module.hot.accept("./CashierPopup.vue?vue&type=template&id=2c5b88bd&scoped=true", function () {
      api.rerender('2c5b88bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/CashierPopup.vue"
export default component.exports